import React, { forwardRef } from 'react';

export const RenderHTML = forwardRef((props, ref) => {
  const { string = '' } = props;
  return (
    <div
      ref={ref}
      className='scroll-mt-[140px]'
      dangerouslySetInnerHTML={{ __html: `${string}` }}
    ></div>
  );
});
